<script setup lang="ts">
  import { useHead } from '@unhead/vue';
  import { computed } from 'vue';

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    },
  });

  const jsonld = computed(() => {
    const articleDetails = props.data?.article_details;
    const publisherLogoUrl = 'https://static2.tripster.ru/img/logo.svg';

    return {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: articleDetails?.title || props.data?.seo?.h1 || '',
      datePublished: articleDetails?.published_at || '',
      dateModified: articleDetails?.updated_at || '',
      description: articleDetails?.intro || props.data?.seo?.description || '',
      image: articleDetails?.main_photo?.scaled || articleDetails?.main_photo?.lightbox || '',
      author: articleDetails?.author
        ? [
            {
              '@type': 'Person',
              name: articleDetails.author.name || 'Tripster',
            },
          ]
        : [
            {
              '@type': 'Person',
              name: 'Tripster',
            },
          ],
      publisher: {
        '@type': 'Organization',
        name: 'Tripster',
        logo: {
          '@type': 'ImageObject',
          url: publisherLogoUrl,
        },
      },
    };
  });

  useHead({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: () => JSON.stringify(jsonld.value),
      },
    ],
  });
</script>

<style scoped></style>
